import React, { Component } from "react";
import { connect } from "react-redux";
import Checkbox from "./Checkbox";
import Style from "style-it";
import Scrollbar from "react-scrollbars-custom";
import withTranslationWrapper from "../../HOC/withTranslation";

class MaintenanceSelectors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list:
        this.props.allPreSelected && this.props.allPreSelected
          ? { scheduled: true, expired: true, required: true, completed: true }
          : {},
      search: "",
      isChecked:
        this.props.allPreSelected && this.props.allPreSelected ? true : false,
    };
  }
  
  componentWillMount() {
    let list = {};
    if (this.props.value && this.props.value.length) {
      this.props.value.map((d) => (list[d] = true));
      this.setState({ list });
    }
  }

  componentWillReceiveProps(nextprops) {
    let list = {};
    if (nextprops.value && nextprops.value.length) {
      nextprops.value.map((d) => (list[d] = true));
    }
    this.setState({ list });
  }

  componentWillUnmount() {
    this.setState({
      list: {},
      search: "",
      isChecked: false,
    });
  }
  
  sendToParent() {
    if (this.props.onChange) {
      this.props.onChange(Object.keys(this.state.list), "maintenance");
    }
  }
  
  onChange = (e, v) => {
    let list = { ...this.state.list };
    if (e.target.checked) {
      list[v.key] = true;
    } else {
      delete list[v.key];
    }
    this.setState(
      {
        list,
        isChecked:
          this.props.maintenanceTypes &&
          this.props.maintenanceTypes.length === Object.keys(list).length,
      },
      () => {
        this.sendToParent();
      }
    );
  };
  
  searchItem = (text) => {
    this.setState({ search: text.target.value });
  };

  toggleItems = (event) => {
    if (event.target.checked) {
      let list = {};
      this.props.maintenanceTypes &&
        this.props.maintenanceTypes.map((d) => (list[d.key] = true));
      this.setState({ list, isChecked: true }, () => {
        this.sendToParent();
      });
    } else {
      this.setState({ list: {}, isChecked: false }, () => {
        this.sendToParent();
      });
    }
  };

  render() {
    let list =
      this.props.maintenanceTypes &&
      this.props.maintenanceTypes.filter(
        (item) =>
          item.name &&
          item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !==
            -1
      );
    
    return (
      <Style>
        {`
        .maintenance-selector-container {
          background: #fff;
        }
        
        .selector-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 12px;
        }
        
        .selector-header-left {
          display: flex;
          align-items: center;
          margin-left: 16px;
        }
        
        .selector-header-right {
          font-size: 12px;
          color: #666;
          font-weight: 500;
        }
        
        .selector-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 6px;
          margin-bottom: 20px;
        }
        
        .selector-item {
          display: flex;
          align-items: center;
          background: #6C34831A;
          padding: 8px;
          border-radius: 4px;
        }
        
        .selector-item label {
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 12px;
          font-weight: 500;
          color: #333;
          margin: 0;
        }
        
        .selector-item .MuiCheckbox-root {
          padding: 4px;
          margin-right: 8px;
        }
        
        .selector-buttons {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          padding-top: 16px;
          border-top: 1px solid #E0E0E0;
        }
        
        .selector-button {
          padding: 8px 24px;
          border: none;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
        }
        
        .selector-button-back {
          background: #424242;
          color: #fff;
        }
        
        .selector-button-back:hover {
          background: #303030;
        }
        
        .selector-button-next {
          background: #1976D2;
          color: #fff;
        }
        
        .selector-button-next:hover {
          background: #1565C0;
        }
        `}
        <div className="maintenance-selector-container">
          {/* Header */}
          <div className="selector-header">
            <div className="selector-header-left">
              <Checkbox
                checked={this.state.isChecked}
                onChange={this.toggleItems}
                label={this.props.translate("selectAll")}
              />
            </div>
            <div className="selector-header-right">
              <span style={{ fontWeight: "700" }}>
              {Object.keys(this.state.list).length}{" "}
              </span>
              {this.props.translate("maintenanceSelected")}
            </div>
          </div>

          {/* Grid of checkboxes */}
          <div className="selector-grid">
            {list &&
              list.map((row) => (
                <div 
                  key={row.id} 
                  className="selector-item"
                  style={{ 
                    background: 
                    row.key === "GarageInitiate" 
                    ? "#1879EB1A" 
                    : row.key === "WaitingForOpApproval" || row.key === "GarageToOp" 
                    ? "#F69B241A"
                    : row.key === "WaitingForCustomerApproval" || row.key === "OpToCustomer" || row.key === "GarageToCustomer"
                    ? "#F69B241A"
                    : row.key === "required" 
                    ? "#1879EB1A"
                    : row.key === "completed" || row.key === "scheduled"
                    ? "#6FBD431A"
                    : row.key === "CustomerToOp" || row.key === "CustomerToGarage"
                    ? "#E33C301A"
                    : "#F57C001A" }}
                >
                  <label>
                    <Checkbox
                      checked={this.state.list[row.key]}
                      value={row}
                      onChange={this.onChange}
                    />
                    <span>{this.props.translate(row.name)}</span>
                  </label>
                </div>
              ))}
          </div>
        </div>
      </Style>
    );
  }
}

const mapState = (state) => ({
  themecolors: state.themeColors,
});
const mapStateToProps = connect(mapState);
export default mapStateToProps(withTranslationWrapper(MaintenanceSelectors));